import SetDisplayNameModal from '@/components/AriseAuth/pages/SetName';

export default function SetDisplayNamePage() {
    return <SetDisplayNameModal />
}
